import { NavLink, Outlet } from "react-router-dom";
import { Accordion, Button } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { encryptLocalStorage } from "../config/utils/storage";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomModal from "../components/common/CustomModal";
import { roleWeights, getRoleName, roles } from "../config/utils/helper";
import HTTP from "../config/axios";
interface Location {
    id: number;
    name: string;
}

const AdminHeader: React.FC = () => {
    const [userName, setUserName] = useState("");
    const [userInfo, setUserInfo] = useState<any>(null);
    const [matchedLocation, setMatchedLocation] = useState<Location | null>(null);
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
    const navigate = useNavigate();
    const [isSalesAdmin, setIsSalesAdmin] = useState(false);
    const [isSourceAdmin, setIsSourceAdmin] = useState(false);
    const [isEnquiryAdmin, setIsEnquiryAdmin] = useState(false);
    const [isCrcAdmin, setIsCrcADMIN] = useState(false);
    const [isHigherRole, setIsHigherRole] = useState(false);
    

    const addActiveClass = (prop: any) => {

        return prop.isActive ? "text-prmiary active" : "text-dark"
    }

    const handleLogout = () => {
        setShowLogoutConfirmation(true);
    };
    const confirmLogout = () => {
        localStorage.clear();
        setShowLogoutConfirmation(false);
        // window.location.href = "/admin/sign-in/"
        // window.location.replace("/admin/sign-in/");
        navigate("/admin/sign-in/")
    };

    const cancelLogout = () => {
        setShowLogoutConfirmation(false);
    };

    const getLocation = async () => {
        try {
            const accessibleDealership = encryptLocalStorage.getItem("accessibleDealership");
            
            if (accessibleDealership && accessibleDealership.length === 1) {
                const singleDealership = accessibleDealership[0];

                const locationData = await HTTP.get(`/api/location/fetch-all-dealerships`);
                const allLocations: Location[] = locationData.data.data;
                
                const foundLocation = allLocations.find(
                    (loc: Location) => loc.id === singleDealership
                );
                
                setMatchedLocation(foundLocation || null);
            } 
        } catch {
        }
    };


    useEffect(() => {
        const userData = encryptLocalStorage.getItem('userInfo')
        setUserInfo(userData);
        setUserName(`${userData?.firstName?.trim()} ${userData?.lastName || ''}`);
        
        const roleUUID = userData?.roleUUID || '';
        const roleWeight = userData?.roleWeight || 0;
        setIsSalesAdmin(roleUUID === roles.SALES_EXECUTIVE);
        setIsSourceAdmin(roleUUID === roles.SOURCE_ADMIN);
        setIsEnquiryAdmin(roleUUID === roles.ENQUIRY_ADMIN);
        setIsHigherRole(roleWeight >= roleWeights.EVALUATOR);
        setIsCrcADMIN(roleUUID === roles.CRC_ADMIN);
        getLocation()
    }, [])

    return (
        <>
            <ul
                className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
                id="accordionSidebar"
            >
                <Link className="sidebar-brand" to="/">
                    <img src={`${process.env.REACT_APP_CLOUDFRONT_URL}/public/pvsLogo.svg`} width="100%" alt="logo"></img>
                </Link>
                <hr className="sidebar-divider my-0" />
                <Accordion className="p-3" flush defaultActiveKey={(isSalesAdmin || isSourceAdmin || isEnquiryAdmin || isCrcAdmin) ? "3" : "0"}>
                    {!(isSalesAdmin || isSourceAdmin || isEnquiryAdmin || isCrcAdmin) && (
                        <>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header><h3>Vehicle</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/make" className={addActiveClass}>Makes</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/model" className={addActiveClass}>Models</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/variants" className={addActiveClass}>Variants</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/vehicles" className={addActiveClass} >Vehicles</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/fuel" className={addActiveClass}>Fuel</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/transmission" className={addActiveClass}>Transmission</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/body-type" className={addActiveClass}>Body types</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/colours" className={addActiveClass}>Colours</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/specification" className={addActiveClass}>Specifications</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/features" className={addActiveClass}>Features</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/inspections" className={addActiveClass}>Inspections</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/report" className={addActiveClass}>Reports</NavLink></p>
                                    {(isHigherRole || isCrcAdmin) && (
                                        <p className="mb-0"><NavLink to="/admin/test-drives" className={addActiveClass}>Test Drives</NavLink></p>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header><h3>Clients</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/clients" className={addActiveClass}>List</NavLink></p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header><h3>Users</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/users" className={addActiveClass}>List</NavLink></p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header><h3>Locations</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/locations" className={addActiveClass}>List</NavLink></p>
                                </Accordion.Body>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/dealerships" className={addActiveClass}>Dealerships</NavLink></p>
                                </Accordion.Body>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/outlets" className={addActiveClass}>Outlets</NavLink></p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </>
                    )}
                    {/* Special case: CRC_ADMIN gets only Vehicle->Test Drives */}
                    {isCrcAdmin && (
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><h3>Vehicle</h3></Accordion.Header>
                            <Accordion.Body className="p-1">
                                <p className="mb-0"><NavLink to="/admin/test-drives" className={addActiveClass}>Test Drives</NavLink></p>
                            </Accordion.Body>
                        </Accordion.Item>
                    )}
                    {/* Enquiries - Visible to specialized roles and higher roles */}
                    {(isSalesAdmin || isSourceAdmin || isEnquiryAdmin || isHigherRole || isCrcAdmin) && (
                        <Accordion.Item eventKey="3">
                            <Accordion.Header><h3>Enquiries</h3></Accordion.Header>
                            <Accordion.Body className="p-1">
                                {/* List (All Enquiries) - SOURCE_ADMIN, ENQUIRY_ADMIN and higher roles can access */}
                                {(isSourceAdmin || isEnquiryAdmin || isHigherRole || isCrcAdmin) && (
                                    <p className="mb-0"><NavLink to="/admin/all-enquiries" className={addActiveClass}>List</NavLink></p>
                                )}
                                
                                {/* Loan Application - All roles can access */}
                                <p className="mb-0"><NavLink to="/admin/loan-application" className={addActiveClass}>Loan application</NavLink></p>
                                
                                {/* Refer & Earn - ENQUIRY_ADMIN and higher roles can access */}
                                {(isEnquiryAdmin || isHigherRole || isCrcAdmin) && (
                                    <p className="mb-0"><NavLink to="/admin/refer-and-earn" className={addActiveClass}>Refer and Earn</NavLink></p>
                                )}
                                
                                {/* Sell Car Enquiries - SOURCE_ADMIN, SALES_EXECUTIVE, ENQUIRY_ADMIN and higher roles can access */}
                                {(isSourceAdmin || isSalesAdmin || isEnquiryAdmin || isHigherRole || isCrcAdmin) && (
                                    <p className="mb-0"><NavLink to="/admin/SellCar-enquiries" className={addActiveClass}>Sell car enquiries</NavLink></p>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    )}
                    {/* Test Drives - Only SALES_EXECUTIVE can access */}
                    {isSalesAdmin && (
                        <Accordion.Item eventKey="9">
                            <Accordion.Header><h3>Test Drives</h3></Accordion.Header>
                            <Accordion.Body className="p-1">
                                <p className="mb-0"><NavLink to="/admin/test-drives" className={addActiveClass}>Test Drives</NavLink></p>
                            </Accordion.Body>
                        </Accordion.Item>
                    )}

                    {!(isSalesAdmin || isSourceAdmin || isEnquiryAdmin || isCrcAdmin) && (
                        <>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header><h3>CMS</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/cms" className={addActiveClass}>CMS List</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/blog" className={addActiveClass}>Blog</NavLink></p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header><h3>Testimonial</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/testimonial" className={addActiveClass}>Testimonial</NavLink></p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header><h3>Bookings</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/bookings" className={addActiveClass}>Bookings</NavLink></p>
                                    <p className="mb-0"><NavLink to="/admin/transactions" className={addActiveClass}>Transactions</NavLink></p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header><h3>Configuration</h3></Accordion.Header>
                                <Accordion.Body className="p-1">
                                    <p className="mb-0"><NavLink to="/admin/bookingConfig" className={addActiveClass}>Booking Amount</NavLink></p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </>
                    )}
                </Accordion>
                {/* User Information Section */}
                {userInfo && (
                    <div className="card shadow-sm border-0 rounded-3 overflow-hidden">
                        <div className="card-body p-3">
                            {/* Profile Header */}
                            <div className="d-flex align-items-center mb-3">
                                <div
                                    className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center shadow-sm"
                                    style={{ width: "35px", height: "35px", fontSize: "14px", fontWeight: "600" }}
                                >
                                    {userInfo.firstName?.charAt(0)?.toUpperCase()}
                                    {(userInfo.lastName || '')?.charAt(0)?.toUpperCase()}
                                </div>
                                <div className="ms-3 flex-grow-1" style={{ minWidth: 0 }}>
                                    <h6 className="mb-0 fw-bold text-dark text-truncate" 
                                        title={`${userInfo.firstName} ${userInfo.lastName || ''}`}>
                                        {userInfo.firstName} {userInfo.lastName || ''}
                                    </h6>
                                    <small className="text-muted text-truncate d-block" 
                                           title={userInfo.email}>
                                        {userInfo.email}
                                    </small>
                                    <small className="text-primary fw-semibold">
                                        {getRoleName(userInfo.roleUUID)}
                                    </small>
                                    <br />
                                    <small className="text-primary fw-semibold">
                                        {matchedLocation?.name}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <h3 className="text-primary p-3" style={{ cursor: 'pointer' }} onClick={handleLogout}>Logout  <FontAwesomeIcon icon={faSignOut} /></h3>
            </ul >
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                    </nav>
                    <div className="mt-2">
                        <Outlet />
                    </div>

                </div>
            </div>
            <CustomModal isOpen={showLogoutConfirmation} title="Logout"
                component={<p>Are you sure you want to continue?</p>}
                closeModal={setShowLogoutConfirmation} buttonList={<>
                    <Button variant="secondary" onClick={cancelLogout}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={confirmLogout}>
                        Logout
                    </Button></>} />
        </>

    );
};

export default AdminHeader;
